import React from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, Smile } from 'lucide-react';

export default function Community() {
  return (
    <section className="py-20 bg-white text-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-5xl font-bold mb-6">BE PART OF SOMETHING SPECIAL</h2>
            <p className="text-xl text-gray-600 mb-8">
              Step into a vibrant community where every workout is shared, every achievement is celebrated, and every member matters. This isn't just a gym – it's your second home.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <Users className="w-6 h-6 text-blue-600 mt-1" />
                <div>
                  <h3 className="text-xl font-bold mb-2">Your Fitness Family</h3>
                  <p className="text-gray-600">Join a community where members become friends, supporting and inspiring each other every step of the way.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <Heart className="w-6 h-6 text-cyan-600 mt-1" />
                <div>
                  <h3 className="text-xl font-bold mb-2">Collective Energy</h3>
                  <p className="text-gray-600">Experience the power of group motivation, where shared goals create unstoppable momentum.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <Smile className="w-6 h-6 text-teal-600 mt-1" />
                <div>
                  <h3 className="text-xl font-bold mb-2">Positive Vibes Only</h3>
                  <p className="text-gray-600">Thrive in an uplifting environment where everyone is welcomed, supported, and encouraged to be their best.</p>
                </div>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-w-4 aspect-h-5">
                <img
                  src="https://i.ibb.co/cXNJK01h/FP-AKL-1.jpg"
                  alt="Fitness Portal Community"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="absolute -bottom-8 -right-8 w-4/5 rounded-2xl overflow-hidden shadow-2xl border-4 border-white"
            >
              <img
                src="https://i.ibb.co/cXNJK01h/FP-AKL-1.jpg"
                alt="Members enjoying time at Fitness Portal"
                className="w-full h-[300px] object-cover"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}